app.controller('hotAlertController', function($http, $scope, $stateParams, $location, dataService, DTColumnBuilder, pageConfig, pageHandler, $timeout, $modal, $anchorScroll, $controller, anchorSmoothScroll)
//function hotAlertInstanceCtrl($scope, $modalInstance, $timeout, dataService, $controller) 
{
	
	//Include custom controller functionality
	$controller('userDefinedHotAlertController', {$scope: $scope});

	$scope.openInfoPopUp = function(message, type, title) {
		type = typeof(type) != 'undefined' ? type : 'success';
		title = typeof(title) != 'undefined' ? title : 'Hot Alert';
        var modalInstance = $modal.open({
            templateUrl: 'views/info_modal.html',
            controller: function($scope, $modalInstance){
            	$scope.info_popup_message = message;
            	$scope.info_popup_type = type;
            	$scope.info_popup_title = title;
            	$scope.ok = function() {
            		$scope.info_popup_message = '';
            		$scope.info_popup_type = '';
            		$scope.info_popup_title = '';
			        $modalInstance.close();
			    };

			    $scope.cancel = function() {
            		$scope.info_popup_message = '';
            		$scope.info_popup_type = '';
            		$scope.info_popup_title = '';
			        $modalInstance.dismiss('cancel');
			    };
            }
        });
    };

	$scope.update = function(url) 
    {
		//validate if comment is null
		var comment = $.trim($("#hot_alert_closed_comment").val());
		var status = $("#hot_alert_closed_status").val();
		
		$('.large_popup_window .alert').removeClass('alert-danger alert-success alert-info').html('').hide();
		
		if(comment != '')
		{
			//show loading
			$('.large_popup_window .alert').html('<div class="spinner"><div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div><div class="rect5"></div></div>');
			$('.large_popup_window .alert').show();

			if(typeof($scope.google_analytics_tracking_code) != 'undefined' && $scope.google_analytics_tracking_code != '')
			{
				var submenu_label = $scope.appState.submenu_key;
				if(typeof($scope.submenu_labels) != 'undefined' && typeof($scope.submenu_labels[$scope.appState.submenu_key]) != 'undefined')
				{
					submenu_label = $scope.submenu_labels[$scope.appState.submenu_key].toLowerCase();
				}
				gtag('event', $scope.appState.page+'_'+submenu_label+'_HA', {'event_category': $scope.appState.page+'_HA', 'event_label': 'HA_'+status});
			}
			
			//Add comment
			var url = url;
			
			var post_data = angular.copy($scope.pageState);
			post_data['app_state'] = $scope.appState;
			post_data['page_mode'] = 'update';
			post_data['comment']   = comment;
			post_data['status']    = status;
			
			dataService.getData(url, post_data , 'POST')
				.then(function(response) {
					
					//hide loading
					$('.large_popup_window .alert').hide();
					
					if(typeof(response.data) != 'undefined')
					{	
						if(typeof(response.data.hot_alert) != 'undefined')
						{
							//hide form
							$('.large_popup_window .popup_request_content').hide();
							
							//show status
							$('.large_popup_window .alert').addClass('alert-success').html(response.message);
							$('.large_popup_window .alert').show();
							
							//update scope
							var componentKey = $scope.componentKey;
							if(typeof($scope[componentKey].selectedRowData.additional.app_metric_hot_alert_status) != 'undefined')
							{
								$scope.openInfoPopUp('<strong>Successfully updated</strong>');
								//alert('Successfully updated');
								$('#hot_alert_submit_form')[0].reset();
								$scope.$parent.showHotAlertForm = false;

								$scope[componentKey].selectedRowData.additional.app_metric_hot_alert_status.value = response.data.hot_alert.hot_alert_status;
								$scope.hotAlertStatus = response.data.hot_alert.hot_alert_status;
								$scope.showTranscript($scope.rowData, $scope.component, componentKey);
								//update survey summary table row to reflect the change
								var status_class = $scope.displayAlertClass(response.data.hot_alert.hot_alert_status);
								
								$($scope[componentKey].selectedRow).find('td:eq(0) i:eq(0)').removeClass('hot_alert_open hot_alert_inprogress').addClass('hot_alert_' + status_class);
								
							}	
							
							//hide update button and change cancel to OK
							$('.large_popup_window .popup_update_button').hide();
							$('.large_popup_window .popup_close_button').html('CLOSE');
						}
						else
						{
							//show status
							//$('.large_popup_window .alert').addClass('alert-danger').html(response.message);
							$scope.openInfoPopUp('response.message','danger');
						}	
					}
				}
			);
		}
		else
		{
			$('.large_popup_window .alert').addClass('alert-danger').html('Comment cannot be empty');
			$('.large_popup_window .alert').show();
		}	
		
        //$modalInstance.close();
    };
	
	$scope.cancel = function() {
		$('#hot_alert_submit_form')[0].reset();
        $('.panel .panel-heading .actions .fa-chevron-up').click();
    };
	
});
